import axios from 'axios';
import {store} from './worksheetStore';

class LearnApiClient {

  constructor() {

    this.url = process.env.API_URL;
    console.log('api on ' + this.url);
  }

  async resolveWorksheetItem(worksheet, item, status, response) {
    const url = this.url + "/worksheets/" + worksheet + "/items/" + item;


    try {

      var data = await axios.post(url,
        {
          "Status": status,
          "Response": response
        },
        {headers: {'X-Trainee-Id': store.state.traineeId}});
    }
    catch (e) {
      data = null;
    }

    return data;
  }

  async startAritmeticTable(tables, operation) {
    const url = this.url + '/lessons/math/arithmetictable';
    console.log(store);
    console.log(store.state.traineeId);

    try {

      var {data} = await axios.post(url,
        {
          "TimesTables": tables,
          "NumbersRange": {"From": "2", "To": "9"},
          "Operation": operation
        },
        {headers: {'X-Trainee-Id': store.state.traineeId}});
    }
    catch (e) {
      data = null;
    }
    return data;
  }

  async existsTrainee(id) {
    const url = this.url + "/trainees/" + id;

    var {data} = await axios.get(url);

    return data;
  }

  async getWorksheet(id) {
    const url = this.url + "/worksheets/" + id;

    var {data} = await axios.get(url, {headers: {'X-Trainee-Id': store.state.traineeId}});

    return data;
  }

  async getWorksheetSummary(id) {
    const url = this.url + "/worksheets/" + id + "/summary";

    var {data} = await axios.get(url, {headers: {'X-Trainee-Id': store.state.traineeId}});
    console.log(data);
    return data;
  }

}

export default new LearnApiClient();



// WEBPACK FOOTER //
// ./src/components/LearnApiClient.js